import { useDispatch, useSelector } from "react-redux";
import { set } from "../redux/asideState";

const getAsideState = state => state.asideState;

const useAsideState = () => {

  const dispatch = useDispatch();
  const aSideState = useSelector( getAsideState );
  const setAsideState = data => { dispatch( set( data ) ) };

  return {
    aSideState,
    setAsideState
  };

};

export default useAsideState;


